import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LuLandingPageSectionTypeAppResource from './LuLandingPageSectionTypeAppResource';
import LuLandingPageCategoryAppResource from "./LuLandingPageCategoryAppResource";

export const REAL_ESTATE = 12010;
export const AGENT_AND_LOAN_OFFICER = 12011;
export const LOAN_OFFICER = 12012;
export const HOME_OWNERSHIP = 12051;

//  LIFE EVENTS
export const BABY_OR_ADOPTION = 12013;
export const GRADUATION = 12014;
export const MARRIAGE = 12015;
export const RETIREMENT = 12016;
export const LEASE_EXPIRATION = 12017;
export const NEW_JOB = 12018;
export const JOB_TRANSFER = 12019;
export const JOB_LOSS = 12020;
export const PROMOTION = 12021;
export const NEW_PET = 12022;
export const ENGAGEMENT = 12023;
export const DIVORCE_OR_BREAKUP = 12024;
export const PREGNANCY = 12025;
export const ILLNESS_OR_INJURY = 12026;
export const DEATH_OF_LOVED_ONE = 12027;
export const INHERITANCE = 12028;
export const FINANCIAL_WINDFALL = 12029;
export const LIFESTYLE_CHANGE = 12030;
export const ECONOMY_AND_FINANCE = 12031;
export const OTHER_LIFE_EVENT = 12032;
export const FIRST_TIME_HOMEBUYER = 12033;
export const EMPTY_NEST = 12052;

// TOPIC OF INTEREST
export const HOME_IMPROVEMENT = 12034;
export const HOME_MANAGEMENT = 12035;
export const HOUSING_MARKET_INFO = 12036;
export const NEWS_OR_INFORMATION = 12037;
export const QUESTION_AND_ANSWER = 12038;
export const REAL_ESTATE_TIPS = 12039;
export const CLIENT_EVENT = 12040;
export const COMMUNITY_SERVICE = 12041;
export const GIVEAWAY_OR_CONTEST = 12042;
export const LOCAL_EVENT = 12043;
export const BUYUNG_ANNIVERSARY = 12044;
export const CLIENT_TESTIMONIAL = 12045;
export const BUSINESS_PARTNERSHIP = 12046;
export const COMPANY_NEWS_AND_EVENTS = 12047;
export const EMPLOYEE_SPOTLIGHT = 12048;
export const NEW_TEAM_MEMBER = 12049;
export const TEAM_RECRUITING = 12050;

export const ALL = {
  REAL_ESTATE,
  AGENT_AND_LOAN_OFFICER,
  LOAN_OFFICER,
  BABY_OR_ADOPTION,
  GRADUATION,
  MARRIAGE,
  RETIREMENT,
  LEASE_EXPIRATION,
  NEW_JOB,
  JOB_TRANSFER,
  JOB_LOSS,
  PROMOTION,
  NEW_PET,
  ENGAGEMENT,
  DIVORCE_OR_BREAKUP,
  PREGNANCY,
  ILLNESS_OR_INJURY,
  DEATH_OF_LOVED_ONE,
  INHERITANCE,
  FINANCIAL_WINDFALL,
  LIFESTYLE_CHANGE,
  ECONOMY_AND_FINANCE,
  OTHER_LIFE_EVENT,
  FIRST_TIME_HOMEBUYER,
  HOME_IMPROVEMENT,
  HOME_MANAGEMENT,
  HOUSING_MARKET_INFO,
  NEWS_OR_INFORMATION,
  QUESTION_AND_ANSWER,
  REAL_ESTATE_TIPS,
  CLIENT_EVENT,
  COMMUNITY_SERVICE,
  GIVEAWAY_OR_CONTEST,
  LOCAL_EVENT,
  BUYUNG_ANNIVERSARY,
  CLIENT_TESTIMONIAL,
  BUSINESS_PARTNERSHIP,
  COMPANY_NEWS_AND_EVENTS,
  EMPLOYEE_SPOTLIGHT,
  NEW_TEAM_MEMBER,
  TEAM_RECRUITING,
  HOME_OWNERSHIP,
  EMPTY_NEST,
};

export const LIFE_EVENTS = [
  BABY_OR_ADOPTION,
  GRADUATION,
  MARRIAGE,
  RETIREMENT,
  LEASE_EXPIRATION,
  NEW_JOB,
  JOB_TRANSFER,
  JOB_LOSS,
  PROMOTION,
  NEW_PET,
  ENGAGEMENT,
  DIVORCE_OR_BREAKUP,
  PREGNANCY,
  ILLNESS_OR_INJURY,
  DEATH_OF_LOVED_ONE,
  INHERITANCE,
  FINANCIAL_WINDFALL,
  LIFESTYLE_CHANGE,
  ECONOMY_AND_FINANCE,
  OTHER_LIFE_EVENT,
  FIRST_TIME_HOMEBUYER,
  EMPTY_NEST,
]

export const TOPIC_OF_INTERESTS = [
  HOME_IMPROVEMENT,
  HOME_MANAGEMENT,
  HOUSING_MARKET_INFO,
  NEWS_OR_INFORMATION,
  QUESTION_AND_ANSWER,
  REAL_ESTATE_TIPS,
  CLIENT_EVENT,
  COMMUNITY_SERVICE,
  GIVEAWAY_OR_CONTEST,
  LOCAL_EVENT,
  BUYUNG_ANNIVERSARY,
  CLIENT_TESTIMONIAL,
  BUSINESS_PARTNERSHIP,
  COMPANY_NEWS_AND_EVENTS,
  EMPLOYEE_SPOTLIGHT,
  NEW_TEAM_MEMBER,
  TEAM_RECRUITING,
];

export const INDUSTRY_PROFESSIONAL = [
    REAL_ESTATE,
    AGENT_AND_LOAN_OFFICER,
    HOME_OWNERSHIP,
    LOAN_OFFICER,
];

class LuLandingPageTypeAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'lu-landing-page-type';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'lus/landings/pages/types';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'id',
      'slug',
      'title',
      'description',
      'isActive',
      'landingPageCategoryUuid',
      'landingPageSectionTypes',
      'order',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      landingPageSectionTypes:             LuLandingPageSectionTypeAppResource,
      category:             LuLandingPageCategoryAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return [
    ];
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      id: {
        type: 'string',
        presence:                 true,
      },
      landingPageCategoryUuid: {
        type: 'string',
      },
      slug: {
        type: 'string',
        presence:                 true,
        length: {
          maximum: 255,
        },
      },
      title: {
        type: 'string',
        presence:                 true,
        length: {
          maximum: 255,
        },
      },
      description: {
        type: 'string',
        length: {
          maximum: 255,
        },
      },
      isActive: {
        type:'boolean'
      },
      order: {
        type: 'integer',
      },
    };
  }

}

export default LuLandingPageTypeAppResource;
